import Vue from 'vue'
import axios from '@/modules/auth/axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
